let fdaDropdowns = document.querySelectorAll('.main_dropdown_wrap .dropdown_txt_wrap');
fdaDropdowns.forEach(d => {
  d.addEventListener('click', function () {
    let targetImgWrap = this.parentElement.querySelector('.dropdown_img_wrap');

    if (!targetImgWrap.classList.contains('active')) {
      // Opening: set height from 0 → scrollHeight + extra space
      targetImgWrap.classList.add('active');
      targetImgWrap.style.height = 'auto'; // Let it expand fully
      let fullHeight = targetImgWrap.scrollHeight + 100 + 'px';

      targetImgWrap.style.height = '0px'; // Reset first
      // Force reflow
      void targetImgWrap.offsetHeight;

      // Then set actual height to animate
      targetImgWrap.style.height = fullHeight;
    } else {
      // Closing: set height from current to 0
      let currentHeight = targetImgWrap.scrollHeight + 100 + 'px';
      targetImgWrap.style.height = currentHeight;

      // Force reflow
      void targetImgWrap.offsetHeight;

      targetImgWrap.style.height = '0px';
      targetImgWrap.classList.remove('active');
    }
  });
});
// let fdaDropdowns = document.querySelectorAll('.main_dropdown_wrap .dropdown_txt_wrap');

// fdaDropdowns.forEach(d => {
//   d.addEventListener('click', function () {
//     let targetImgWrap = this.parentElement.querySelector('.dropdown_img_wrap');

//     if (targetImgWrap.style.display === 'block') {
//       targetImgWrap.style.display = 'none';
//       targetImgWrap.classList.remove('active');
//     } else {
//       targetImgWrap.style.display = 'block';
//       targetImgWrap.classList.add('active');
//     }
//   });
// });

